import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { IHousingUnit } from 'app/models/housingunits/housing-unit';
import { HousingUnitService } from 'app/services/housingunit-service';
import { HousingUnitAssociations } from 'app/models/housingunits/housing-unit-associations';

/*
 * Edit Associated Housing Unit Dialog
 */
@Component({
  selector: 'dialog-housingunit-association-edit',
  templateUrl: 'housingunit-association-edit-dialog.html',
  styleUrls: ['./housingunit-association-edit-dialog.scss']
})
export class DialogEditHousingUnitAssociationComponent implements OnInit {
  @Input('housingUnitId')
  housingUnitId: number = 0;

  @Input('householdHousingUnitKey')
  householdHousingUnitKey: number = 0;

  loading: boolean = false;
  processing: boolean = false;

  housingUnit: IHousingUnit = {
    id: 0,
    wellHousingUnitKey: 0,
    householdHousingUnitKey: 0,
    householdHousingUnitStartDate: '',
    householdHousingUnitEndDate: '',
    createDate: '',
    createdby: '',
    lastUpdatedBy: '',
    lastUpdated: '',
    modifiedBy: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    contactCellPhone: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    county: '',
    ownerFirstName: '',
    ownerLastName: '',
    ownerEmail: '',
    preferredContactMethod: '',
    latitude: 0,
    longitude: 0,
    comments: '',
    unitNumber: '',
    housingUnitDataSource: '',
    taxLotId: '',
    municipality: '',
    sourceComments: '',
    ohaComments: '',
    sourceID: '',
    map: '',
    taxLot: '',
    acres: '',
    unitType: '',
    acceptedServices: ''
  };

  housingUnitAssocations: HousingUnitAssociations = {
    households: [],
    housingUnit: this.housingUnit,
    housingUnits: [],
    wells: [],
    housingUnitStartDate: '',
    housingUnitEndDate: '',
    householdHousingUnitKey: 0,
    wellId: 0,
    createNewWell: false,
    newAddress1: '',
    newCity: '',
    newZip: '',
    newCounty: '',
    housingUnitId: 0,
    newContactName: ''
  };

  housingUnitForm = new FormGroup({
    id: new FormControl(0),
    housingUnitStartDate: new FormControl(new Date()),
    housingUnitEndDate: new FormControl(new Date())
  });

  constructor(public oregonWellDataService: OregonWellDataService,
    public housingUnitService: HousingUnitService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: number[],
    private dialogRef: MatDialogRef<DialogEditHousingUnitAssociationComponent>) {
    this.housingUnitId = this.data['housingUnitId'];
    this.householdHousingUnitKey = this.data['householdHousingUnitKey'];
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    if (this.housingUnitId <= 0) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.housingUnitService.getHousingUnitAssociationById(this.housingUnitId, this.householdHousingUnitKey).subscribe(
      result => {
        this.housingUnitAssocations = result;
        this.setFormValues();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  getFormvalues() {
    this.housingUnitAssocations.householdHousingUnitKey = this.householdHousingUnitKey;

    if (this.housingUnitForm.value.housingUnitStartDate == null
      || this.housingUnitForm.value.housingUnitStartDate.toString() == "Invalid Date"
      || this.housingUnitForm.value.housingUnitStartDate.toString() == '') {

      this.housingUnitForm.controls['housingUnitStartDate'].setValue(null);
      this.housingUnitAssocations.housingUnitStartDate = null;

    }
    else {
      this.housingUnitAssocations.housingUnitStartDate = new Date(this.housingUnitForm.value.housingUnitStartDate);
    }

    if (this.housingUnitForm.value.housingUnitEndDate == null
      || this.housingUnitForm.value.housingUnitEndDate.toString() == "Invalid Date"
      || this.housingUnitForm.value.housingUnitEndDate.toString() == '') {

      this.housingUnitForm.controls['housingUnitEndDate'].setValue(null);
      this.housingUnitAssocations.housingUnitEndDate = null;

    }
    else {
      this.housingUnitAssocations.housingUnitEndDate = new Date(this.housingUnitForm.value.housingUnitEndDate);
    }
  }

  setFormValues() {
    this.housingUnitForm.get("housingUnitStartDate").setValue((new Date(this.housingUnitAssocations.housingUnitStartDate)));
    this.housingUnitForm.get("housingUnitEndDate").setValue((new Date(this.housingUnitAssocations.housingUnitEndDate)));
  }

  updateHousingUnitAssociation() {
    this.processing = true;
    this.getFormvalues();

    this.housingUnitService.saveHousingUnitAssociation(this.housingUnitAssocations).subscribe(
      result => {
        this.toastr.success("Housing Unit Association Saved");
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.dialogRef.close();
      }
    );
  }
}